import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'

import { prefixer } from 'lib/emotion-prefixer'

export const cacheOptions = {
  key: 'g',
  stylisPlugins: [prefixer],
  speedy: true
}

export const gremlinCache = createCache(cacheOptions)

export default function EmotionProvider(props) {
  return <CacheProvider value={gremlinCache} {...props} />
}
